import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../document.module.scss';
import grid from '../../../icons/grid_view.svg';
import list from '../../../icons/list.svg';

class toolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { handleview, displayview } = this.props;
    return (
      <div className={styles.toolbar}>
        <FormattedMessage id="documents.toolbar.title" defaultMessage="All Documents" />
        <div className={styles.icon_view}>
          <div className={styles.grid_view} onClick={() => handleview(true)}
            onKeyPress={() => handleview(true)} role="button" tabIndex={0}>
            <img className={displayview === true ? styles.active : ''} src={grid} alt="" />
          </div>
          <div className={styles.list_view} onClick={() => handleview(false)}
            onKeyPress={() => handleview(false)} role="button" tabIndex={0}>
            <img className={displayview === true ? '' : styles.active} src={list} alt="" />
          </div>

        </div>
      </div>
    );
  }
}

export default toolbar;
